import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'tag',
	prefix: 'tag',
	key: 'tag_id',
	fields: {
		tag_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		group_id: Model.SCHEMA_NUMBER,
		buddies_id: Model.SCHEMA_NUMBER,
		family_id: Model.SCHEMA_NUMBER,
		tag_context: Model.SCHEMA_NUMBER,
		tag_public: Model.SCHEMA_NUMBER,
		tag_text: Model.SCHEMA_TEXT,
		tag_colour: Model.SCHEMA_TEXT,
		tag_fore: Model.SCHEMA_TEXT,
		tag_attachments: Model.SCHEMA_NUMBER
	}
})
